import UiAction from "./index";

// selector,
// radioButtonsSelector,
// detailsSelector,
// hasCallToAction = true,
// hasSubPage = false,
// isSubPageDetailsRequired = false,
// isSubPage = false
// when the form is creating one new info post only
// at app/views/info_posts/_form.html.slim
$(() => {
  if ($("#info_post").length > 0) {
    const infoPostUiAction = new UiAction(
      ".main_ui_actions",
      ".main_ui_action_radio_buttons",
      ".main_ui_action_items",
      {
        isSubPageRequired: true,
        isSubPage: false,
      },
      {
        hasCallToAction: true,
        hasSubPage: true,
      }
    );
    infoPostUiAction.attach();
  }
});
